import React from 'react';
import ReactPlayer from 'react-player';
import ModalInspection from '../../components/ModalInspection';
import PropTypes from 'prop-types';

function ModalInformationRemarks(props) {
  const {openModal, setOpenModal, modalData} = props;
  const renderContent = () => {
    if (!modalData) return null;
    let content = [];
    if (modalData.remark_video) {
      content.push(
        <div className="mt-3">
          <p>動画:</p>
          <ReactPlayer url={modalData.remark_video}
                       width=""
                       height=""
                       className="w-full h-full max-w-[640px] max-h-[360px]"
                       controls={true}
                       playing={true}/>
        </div>
      );
    }
    if (modalData.remark_image) {
      content.push(
        <div className="mt-3">
          <p>画像:</p>
          <img src={modalData.remark_image} alt="remark"
               className="w-full h-auto max-w-[640px]"/>
        </div>
      );
    }
    if (modalData.remark_text) {
      content.push(
        <div className="space-y-6 mt-3">
          <p className="text-base leading-relaxed">要注意: {modalData.remark_text}</p>
        </div>
      );
    }
    return content;
  };

  return (
    <ModalInspection show={openModal}
                     onClose={() => setOpenModal(false)}
                     renderContent={() => (
                       <>
                         <div className="2xl:mb-[16px] xl:mb-[14px] md:mb-[12px] leading-6">
                           <p>点検項目: <span
                             style={{color: modalData && modalData.title_color}}>{modalData && modalData.title}</span>
                           </p>
                           <p>判定基準: <span
                             style={{color: modalData && modalData.description_color}}>{modalData && modalData.description}</span>
                           </p>
                         </div>
                         {renderContent()}
                       </>
                     )}/>
  );
}

ModalInformationRemarks.propTypes = {
  openModal: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  modalData: PropTypes.shape({
    remarks: PropTypes.string,
    video_url: PropTypes.string,
    text: PropTypes.string,
    inspection_item: PropTypes.string,
    judgment_criteria: PropTypes.string,
  }),
  type: PropTypes.string
};

export default ModalInformationRemarks;
